const { 
    VUE_APP_API_BASE_URL: apiBaseUrl, 
    VUE_APP_API_KEY: apiKey, 
    VUE_APP_MIXPANEL_KEY: key 
} = process.env
const config = {
    apiBaseUrl,
    apiKey,
    key
}

export default config